import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from "./components/ui/toaster"
import { AuthProviderWrapper } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Services from './pages/Services';
import Groups from './pages/Groups';
import Permissions from './pages/Permissions';
import Users from './pages/Users';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProviderWrapper>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/services" replace />} />
            <Route path="services" element={<Services />} />
            <Route path="groups" element={<Groups />} />
            <Route path="permissions" element={<Permissions />} />
            <Route path="users" element={<Users />} />
          </Route>
        </Routes>
        <Toaster />
      </AuthProviderWrapper>
    </Router>
  );
}

export default App; 